import React, { useEffect, useState } from "react";
import { useAuth } from "../../../../context/API_Client";
import { Typography } from "@mui/material";
import "./../webhooks.css";
import InputSeachWebHooks from "./inputSeachWebHooks";
import BoxPayGrid from "../../../BoxPayGrid";
import { notificationSchema } from "./notificationSchema";
import LoadingLogoPage from "../../../loadingPage/loadingPage";
import { useLocation } from "react-router-dom";
import { currentTimeInTimezone } from "../../../utils/utils";
import { toast } from "react-toastify";
import { customToast } from "../../../../reusableComponents/customToaster/customToast";

function WebhookLogs() {
  const { getAllVisualizationData, merchantSettings } = useAuth();
  const [gridData, setGridData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [paymentError, setPaymentError] = useState([]);
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [selectedDate, setSelectedDate] = useState({});
  const [isSearching, setIsSearching] = useState(false);
  const [timeZone, setTimeZone] = useState();
  const [searchLoader, setSearchLoader] = useState(false)

  const location = useLocation();
  const queryParameters = new URLSearchParams(location.search);
  let webhookUrl = queryParameters.get("webhookUrl");

  useEffect(() => {
    merchantSettings(
      function (data) {
        setTimeZone(data?.timeZone);
      },
      function (errMsg) {
        customToast("error", "high", errMsg);
      }
    );
  }, []);

  useEffect(() => {
    if (timeZone) {
      handleSearchData("", "");
    }
  }, [timeZone]);

  const handleSearchData = (attrName, values) => {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    let fromDate = new Date(currentYear, 0, 1);
    fromDate.setHours(0, 0, 0, 0);
    let toDate = new Date();
    toDate.setHours(23, 59, 59, 999);
    fromDate = fromDate
    toDate = toDate;
    if (values?.length > 0) {
      setIsSearching(true);
    }
    const filters = [];
    if (Array.isArray(values) || values.length > 0) {
      filters.push({
        attrName: attrName,
        operator: "contains",
        values: [values],
      });
    }
    setSearchLoader(true)
    getAllVisualizationData(
      "entities/status_notifications",
      {
        fromDate: fromDate,
        toDate: toDate,
        limit: 100,
        advancedAttributeFilters: filters,
      },
      function (data) {
        setFilteredData(data?.points);
        setLoading(false);
        setSearchLoader(false)

      },
      (errorMsg) => {
        setPaymentError(errorMsg);
        setSearchLoader(false)
        setLoading(false);
      }
    );
  };

  const [withoutSearchbarModalData, setWithoutSearchbarModalData] = useState(
    []
  );
  const [withSearchbarModalData, setWithSearchbarModalData] = useState([]);

  const handleWithoutSearchbarModalData = (data) => {
    setWithoutSearchbarModalData(data);
  };
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleDateSelection = (date) => {
    setSelectedDate(date);
  };

  const handleSearchbarModalData = (data) => {
    setWithSearchbarModalData(data);
  };

  const dates = [
    { key: "Last 15 minutes", value: "last15Minutes" },
    { key: "Last 24 hours", value: "last24Hours" },
    { key: "Last week", value: "lastWeek" },
    { key: "Single date", value: "singleDate" },
    { key: "Date range", value: "dateRange" },
  ];

  return (
    <>
      {loading ? (
        <div>
          <section
            style={{
              display: "flex",
              marginTop: "24px",
              justifyContent: "center",
              alignItems: "center",
              height: loading ? "50vh" : "auto",
            }}
          >
            <LoadingLogoPage />
          </section>
        </div>
      ) : filteredData && (filteredData?.length > 0 || isSearching) ? (
        <section className="mainDivWebHooks">
          <div
            style={{
              width: "100%",
            }}
          >
            <InputSeachWebHooks
              searchData={handleSearchData}
              webhookUrl={webhookUrl}
            />
          </div>
           <div style={{ marginTop: "32px", width: "100%", display: "flex" }}>
            <BoxPayGrid
              schema={notificationSchema}
              data={filteredData}
              showCustomizeButton={false}
              loader={searchLoader}
            />
          </div>
        </section>
      ) : (
        <div style={{ backgroundColor: "white" }}>
          <div className="mainDiv">
            <div className="innerDiv">
              <img
                src="/assets/webHooksLogo.svg"
                alt="web hook"
                className="iconStyle"
              />
              <div className="textDiv">
                <Typography className="headerH3Medium font-black-highest">
                  Webhooks Logs
                </Typography>
                <Typography className="bodyB2RegularText font-black-high">
                  Chronological record of webhook log activity
                </Typography>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default WebhookLogs;
